import { Face1, Face2, Face3, Face4, Face5 } from './faces';

export const EMOJI_RATING = {
  1: Face1,
  2: Face2,
  3: Face3,
  4: Face4,
  5: Face5,
};
